import { SAVE_NATIONALITY, FETCH_NATIONALITY, FETCH_NATIONALITY_FAIL } from '../actions/types';


export function SaveNationality(state = [], action){
  switch (action.type) {
    case SAVE_NATIONALITY:
      return JSON.parse(action.payload).data;
    default:
      return state;
  }
}


export function FetchNationality(state = [], action){
  switch (action.type) {
    case FETCH_NATIONALITY:
      return action.payload.data.data;
    case FETCH_NATIONALITY_FAIL:
      return [];
    default:
      return state;
  }
}



// WEBPACK FOOTER //
// ./src/reducers/reducer_nationality.js